import ElementBaseModel from '@src/slide/domain/ui-model/element-modeles/base-modeles/element-base-model';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

export class ChartBaseModel extends ElementBaseModel {
    constructor() {
        super();
        this.type = UIModelType.CHART;
    }
}

export class SubChartBaseModel extends ElementBaseModel {
    public uniqueId: string;

    constructor() {
        super();

        // 随机生成唯一标识，用于判断subChartModel是否完全变更
        this.uniqueId = `${Math.random().toString(16)}-${Date.now()}`;
    }
}
